import Style from './OperationText.styled';

const OperationText = (props) => {
  const { children } = props;

  return <Style.OperationTextContainer>{children}</Style.OperationTextContainer>;
};

export default OperationText;
